<template>
  <page layoutClass="projects-index" :err="err">
    <!-- Header -->
    <b-row class="my-3">
      <b-col cols="12" sm="7">
        <h2 class="m-0">Jobs</h2>
      </b-col>
      <b-col cols="12" sm="5" class="d-flex flex-row justify-content-end align-items-center" v-if="isRecruiter && showAddJobsButton">
        <b-button size="md" variant="outline-primary" :to="{ name: 'JobNew' }">
          <font-awesome-icon icon="plus"/>
          <span class="d-none d-sm-inline-block">Add New</span>
        </b-button>
      </b-col>
    </b-row>

    <internal-jobs-list
      layout="block"
      :loading="$apollo.loading || !jobs"
      :where="filterJobsWhere"
      :whereCustomFields="jobs ? jobs.jobAggs : null"
      @whereUpdated="filterJobsWhereUpdated"
      :results="jobs ? jobs.jobConnections : null"
      @pageUpdated="filterJobsPageUpdated"
      :order="filterJobsOrder"
      @orderUpdated="filterJobsOrderUpdated"
    />
  </page>
</template>

<script>
import base64 from 'base-64';
import ms from 'ms';
import enumsMixin from '@src/mixins/enums';
import InternalJobsList from '@/components/projects/InternalJobsListContainer';
import Page from '@/components/Page';
import InternalJobsIndex from '@/graphql/queries/InternalJobsIndex.gql';
import { mapRoot } from '@src/mixins/root';

export default {
  components: {
    Page,
    InternalJobsList,
  },
  mixins: [
    enumsMixin,
  ],
  data: () => ({
    err: null,
    filterJobsWhere: {
      NOT: {
        isInternal: false
      },
      project: null,
      status: 'ACTIVE',
    },
    filterJobsPage: 1,
    filterJobsLimit: 20,
    filterJobsOrder: 'CREATED_DESC',
  }),
  created() {
    if (this.company && this.company.sitePreferences) {
      const { company: { sitePreferences } } = this;
      this.filterJobsOrder = sitePreferences.defaultInternalJobOrderBy || this.filterJobsOrder;
      this.filterJobsOrder = this.$route.query ? (this.$route.query.order || this.filterJobsOrder) : this.filterJobsOrder;
    }

    if (this.$route && this.$route.query && this.$route.query.filter) {
      const { where, order, page, limit } = JSON.parse(base64.decode(this.$route.query.filter));
      this.$log.debug({ where, order, page, limit });

      if (typeof where === 'object') {
        this.filterJobsWhere = { ...this.filterJobsWhere, ...where };
      }
      if (typeof order === 'string') {
        this.filterJobsOrder = order;
      }
      if (typeof page === 'number') {
        this.filterJobsPage = page;
      }
      if (typeof limit === 'number') {
        this.filterJobsLimit = limit;
      }
    }
  },
  apollo: {
    jobs: {
      query: InternalJobsIndex,
      variables() {
        const { filterJobsWhere: where, filterJobsOrder: order, filterJobsPage: page, filterJobsLimit: limit } = this;
        return { where, order, page, limit };
      },
      update(data) {
        const { company: { jobConnections, jobAggs } = {} } = data;
        return { jobConnections, jobAggs };
      },
      error(err) {
        this.$log.error(err);
      },
      errorPolicy: 'all',
      fetchPolicy: 'cache-and-network',
      deep: true,
      throttle: ms('1s'),
    },
  },
  metaInfo() {
    return {
      title: 'Internal Jobs',
    };
  },
  computed: {
    ...mapRoot([ 'company', 'isLoggedIn', 'isRecruiter' ]),
    showAddJobsButton() {
      const { showAddJobsButton = false } = this.company.sitePreferences;
      return showAddJobsButton;
    },
  },
  methods: {
    filterJobsWhereUpdated(where) {
      if (JSON.stringify(this.filterJobsWhere) !== JSON.stringify(where)) {
        this.filterJobsWhere = where;
        this.filterJobsPage = 1;

        this.updateRouteFilter({ where });
        this.$scrollTo('body');
      }
    },
    filterJobsOrderUpdated(order) {
      this.filterJobsOrder = order;
      this.filterJobsPage = 1;

      this.updateRouteFilter({ page: undefined, order });
      this.$scrollTo('body');
    },
    filterJobsPageUpdated(page) {
      this.filterJobsPage = page;
      this.updateRouteFilter({ page });
      this.$scrollTo('body');
    },
    updateRouteFilter(values) {
      const existing = this.$route && this.$route.query ? this.$route.query.filter : null;
      this.$router.push({
        ...this.$route,
        query: {
          filter: base64.encode(JSON.stringify({
            ...(existing ? JSON.parse(base64.decode(existing)) : {}),
            ...values
          })),
        },
      });
    },
  },
};
</script>
<style lang="scss">
.page .projects-index {

  h2 {
    margin-bottom: 0.75em;
  }

}
</style>



// WEBPACK FOOTER //
// src/views/jobs/internalJobsIndex.vue